import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { Checkbox, Fade, Menu, MenuItem } from '@mui/material';
import React, { FC } from 'react';
import { DateRangePicker } from 'react-date-range';
import { useTranslation } from 'react-i18next';

import { Icons } from '../../../assets/SvgIcons';
import classes from './CustomFilterMenu.module.css';

type ItemProps = {
  key: string;
  value: string;
  htmlValue?: React.ReactNode;
};

type IProps = {
  items: ItemProps[];
  title: React.ReactNode;
  clearTitle?: string;
  clearButton: boolean;
  handleItemClick: (data: ItemProps) => void;
  setRange?: (obj: any) => void;
  multiSelect?: boolean;
  type: 'default' | 'left-check' | 'right-check' | 'calendar';
  selectedItems?: ItemProps[];
  icon?: React.ReactNode;
  handleClickClear?: () => void;
};

const CustomFilterMenu: FC<IProps> = ({
  items,
  title,
  clearButton,
  clearTitle,
  handleItemClick,
  setRange,
  multiSelect,
  type,
  selectedItems,
  icon,
  handleClickClear,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const [state, setState] = React.useState({
    selection: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
    compare: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'compare',
    },
  });
  const { t } = useTranslation();
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderItem = () => {
    if (type === 'default') {
      return (
        <div>
          {items?.map((item, index) => (
            <MenuItem
              key={index}
              style={{ fontFamily: 'Inter' }}
              onClick={() => {
                handleItemClick(item);
                handleClose();
              }}
            >
              {item.value}
            </MenuItem>
          ))}
        </div>
      );
    }
    if (type === 'left-check') {
      return (
        <div>
          {items?.map((item, index) => (
            <MenuItem
              key={index}
              style={{ fontFamily: 'Inter' }}
              className={classes.leftCheck}
              onClick={() => {
                handleItemClick(item);
              }}
            >
              <Checkbox
                sx={{
                  '&.Mui-checked': {
                    color: '#5243aa',
                  },
                }}
                inputProps={{ 'aria-label': 'controlled' }}
                checked={
                  selectedItems?.find(s => s.key === item.key) ? true : false
                }
              />
              {item.htmlValue ? item.htmlValue : item.value}
            </MenuItem>
          ))}
        </div>
      );
    }
    if (type === 'right-check') {
      return (
        <div>
          {items?.map((item, index) => (
            <MenuItem
              key={index}
              style={{ fontFamily: 'Inter' }}
              className={classes.rightCheck}
              onClick={() => {
                handleItemClick(item);
              }}
            >
              {item.htmlValue ? item.htmlValue : item.value}
              <Checkbox
                sx={{
                  '&.Mui-checked': {
                    color: '#5243aa',
                  },
                }}
                inputProps={{ 'aria-label': 'controlled' }}
                checked={
                  selectedItems?.find(s => s.key === item.key) ? true : false
                }
              />
            </MenuItem>
          ))}
        </div>
      );
    }
    if (type === 'calendar') {
      return (
        <div>
          {items?.map((item, index) => (
            <div onClick={() => {}} key={index}>
              {
                <DateRangePicker
                  onChange={(a: any) => {
                    setState(a);
                    if (setRange) setRange(a);
                    console.log('item a', a);

                    handleItemClick(item);
                  }}
                  months={1}
                  direction="vertical"
                  scroll={{ enabled: true }}
                  ranges={[state.selection] as any}
                />
              }
            </div>
          ))}
        </div>
      );
    }
  };

  const clearClickButton = () => {
    handleClickClear && handleClickClear();
    handleClose();
  };

  return (
    <div>
      <button
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={[
          classes.IconButton,
          classes.IconButtonPrimary,
          (open || (selectedItems && selectedItems?.length > 0)) &&
            classes.IconButtonActive,
        ].join(' ')}
      >
        <div className={classes.buttonTitle}>
          {selectedItems && selectedItems?.length > 0
            ? selectedItems?.map(i => {
                return <span key={i.key}>{i.value}</span>;
              })
            : title}{' '}
        </div>
        {icon ? icon : <Icons.ChevronDown />}
      </button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        PaperProps={{
          style: {
            background: '#ffffff',
            border: ' 1px solid #ebebf0',
            boxSizing: 'border-box',
            boxShadow: ' 0px 8px 16px rgba(0, 0, 0, 0.1)',
            borderRadius: 4,
            padding: '8px 8px 6px',
            minWidth: 208,
            marginTop: 10,
          },
        }}
      >
        <div className={classes.title}>{clearTitle ? clearTitle : title}</div>
        {renderItem()}
        {clearButton && (
          <MenuItem onClick={clearClickButton} className={classes.clearButton}>
            <Icons.Cancel color="#ff5630" />{' '}
            <span
              style={{ color: '#ff5630', fontFamily: 'Inter', fontWeight: 600 }}
            >
              {t('dependencies.list_tab.clear_filter')}
            </span>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default CustomFilterMenu;
